























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ExportType, FileHandler } from '@/helpers/fileManager';
import { convertMarkdownToHTML, globalState, IGlobalState } from '@/shared';

@Component({
  components: {},
})
export default class MenuPanel extends Vue {
  menuVisible = false;
  globalState: IGlobalState = globalState;

  wordCount = 0;
  charCount = 0;
  readMinutes = '';

  @Watch('globalState.editorContentHtml')
  onChildChanged() {
    setTimeout(() => {
      this.onTextChange();
    }, 100);
  }

  onTextChange() {
    const text = document.querySelector('.ProseMirror')?.textContent ?? '';
    this.wordCount = text.trim().split(/\s+/).length;
    this.charCount = text.length;
    const readSecondsNum = (this.wordCount / 265) * 60;
    this.readMinutes = this.secondsToString(readSecondsNum);
  }

  secondsToString(inputSeconds: number) {
    const numyears = Math.floor(inputSeconds / 31536000);
    const numdays = Math.floor((inputSeconds % 31536000) / 86400);
    const numhours = Math.floor(((inputSeconds % 31536000) % 86400) / 3600);
    const numminutes = Math.floor((((inputSeconds % 31536000) % 86400) % 3600) / 60);
    const numseconds = Math.ceil(((inputSeconds % 31536000) % 86400) % 3600) % 60;

    const years = numyears ? `${numyears + 'y '}` : '';
    const days = numdays ? `${numdays + 'd '}` : '';
    const hours = numhours ? `${numhours + 'h '}` : '';
    const minutes = numminutes ? `${numminutes + 'm '}` : '';
    const seconds = numseconds ? `${numseconds + 's '}` : '';

    return years + days + hours + minutes + seconds;
  }

  async openFileDialog() {
    this.menuVisible = false;
    const text = await FileHandler.openFileDialog();
    if (text) {
      globalState.editorContentHtml = convertMarkdownToHTML(text);
      globalState.isEmpty = this.globalState.editorContentHtml.length < 8;
    }
  }

  newEmptyDoc() {
    globalState.editorContentHtml = '';
    this.menuVisible = false;
  }

  async exportFileDialog(type: ExportType) {
    await FileHandler.exportFileDialog(type, this.globalState.editorContentHtml);

    // try {
    //   const filePath = (await save({ filter: 'md' })) as string;
    //   await writeFile({ path: filePath, contents: this.globalState.editorContentHtml });
    // } catch (error) {
    //   console.log(error);
    // }
  }
}
